import { displayName, type WorkspaceUserDto } from '@schwrz/shared';

/**
 * Users who may be assigned to tasks for a given company: all employees plus
 * company representatives tied to that client.
 */
export function assignableUsersForClient(
  users: WorkspaceUserDto[],
  clientId: string | null | undefined,
): WorkspaceUserDto[] {
  const employees = users.filter((u) => u.membershipType === 'employee');
  if (!clientId) return sortByName(employees);
  const reps = users.filter(
    (u) => u.membershipType === 'company' && u.companyId === clientId,
  );
  return sortByName([...employees, ...reps]);
}

function sortByName(users: WorkspaceUserDto[]): WorkspaceUserDto[] {
  return [...users].sort((a, b) => displayName(a).localeCompare(displayName(b), 'ru'));
}
